module Core {
    @Component('core', 'voteMerci', {
        controllerAs: 'vm',
        templateUrl: './voteMerci.html'
    })
    class VoteMerciComponent {
    }
}